import { Redirect, useLocation } from "react-router-dom";
import { authRoutes, toAuthUrl } from "utils/authModal";

/** Preserve bookmarked auth URLs and password-reset email links. */
const AuthRedirect = () => {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const type = params.get("type");
	if (location.pathname === "/register") params.delete("type");
	return (
		<Redirect
			to={toAuthUrl(
				{ pathname: "/", search: params.toString(), hash: location.hash },
				authRoutes[location.pathname],
				{ type },
			)}
		/>
	);
};

export default AuthRedirect;
